export default __webpack_public_path__ + "static/media/i-360video-connect.dc9782af.svg";